// CheckBoxGroupWithText.js
import { useState, useEffect } from "react";
import { Grommet, Box, CheckBox, Image, Text } from "grommet";
import { updateStateHandler, DrawArrayByRows } from "../Utils/Utils";


const customBunchTheme = {
    checkBox: {
        border: {
            width: '2px',
            color: "#00739D",  
        },
        hover: {
            border: {
                color: "#02445c",
            },
        },               
        size: '20px', // affects the size of the outer circle 
        color: "#00739D",    
    },    
};


const CheckBoxGroupWithText = (props) => {
    const {choices, title, groupkey, numOfColumns} = props;
    const [checked, setChecked] = useState([]);
    // console.log('CheckBoxGroupWithText props  >>  ', props);
    
    const handleCheck = (event, item) => {
        updateStateHandler(props.stateHandler, item.stateKey, event.target.checked );
    };
    
    const DrawItem = (item, key) =>
    {
        // console.log("item >> ",item);      
        return(
            <Grommet theme={customBunchTheme} key={key}>
            <Box height="small" width="small" key={item.stateKey} pad="small" margin={{vertical: "none"}} align="start" justify="center" fill>
                <Box direction="row"  pad={{vertical: "5px"}} alignContent="start" align="start" width="160px" height="10px" style={{margin: "0 auto"}}>
                    <CheckBox  value={item.value} 
                        disabled={props.disable} 
                        checked={item.checked ? item.checked : false} 
                        onChange={ event => handleCheck(event, item)}
                        pad={{horizontal: "5px"}}
                    >
                    </CheckBox>  
                    <Text alignSelf="start" size="medium">
                    {item.label}
                    </Text>                   
                </Box>        
            </Box> 
            </Grommet>
        );
    };


    return (
        <Box direction="column" pad="small" align="center"
            gap="xxsmall"
            // fill="horizontal"
            margin={{vertical: "small"}}
            width = '200px'
        >
            <Box alignSelf="start" pad={{horizontal: "small"}}>
                <Text alignSelf="start" color="brand" size="18px">
                <strong>{title}</strong>
                </Text>
            </Box>
            {DrawArrayByRows(choices, numOfColumns, groupkey, DrawItem)}
        </Box>
    );
};

export default CheckBoxGroupWithText;
